import { supabase } from '../supabaseClient';

// Send a message via server-side RPC (B1: rate-limited at SQL level).
// Throws on Supabase error; throws { code: 'RATE_LIMIT', seconds: N } on cooldown.
// Note: `username` param kept for API compatibility but server derives it from JWT.
export const sendMessage = async (roomCode, _username, message) => {
  const { error } = await supabase.rpc('send_message_rpc', {
    p_room_code: roomCode,
    p_message: message,
  });

  if (error) {
    // Parse server-side rate-limit signal: message format is 'RATE_LIMIT:<seconds>'
    if (error.message?.startsWith('RATE_LIMIT:')) {
      const seconds = parseInt(error.message.split(':')[1], 10) || 5;
      const rlError = new Error('Rate limit exceeded');
      rlError.code = 'RATE_LIMIT';
      rlError.seconds = seconds;
      throw rlError;
    }
    throw error;
  }
};

// Get message history for a room (last N messages, oldest-first)
export const getMessageHistory = async (roomCode, limit = 50) => {
  // Fetch in descending order then reverse so oldest-first in UI
  const { data, error } = await supabase
    .from('messages')
    .select('*')
    .eq('room_code', roomCode)
    .order('created_at', { ascending: false })
    .limit(limit);

  if (error) throw error;
  return (data || []).reverse();
};

// Subscribe to new messages in room (real-time)
export const subscribeToMessages = (roomCode, callback) => {
  const channel = supabase
    .channel(`room-messages:${roomCode}`)
    .on('postgres_changes',
      { event: 'INSERT', schema: 'public', table: 'messages', filter: `room_code=eq.${roomCode}` },
      (payload) => callback(payload.new)
    )
    .subscribe();

  return () => channel.unsubscribe();
};
